import { useParams } from "react-router-dom";
import { MapView } from "../../../../constant/VectorTileLayerType";
import CountryVectorTileLayer from "../../layers/CountryVectorTiles/CountryVectorTileLayer";

const includedCountries: string[] = ["CA", "GB", "US"];

const InrixVolumeMapView = () => {
  const visible = useParams().layer === MapView.INRIX_VOLUME;

  return (
    <CountryVectorTileLayer visible={visible} inclusions={includedCountries} />
  );
};

export default InrixVolumeMapView;
